import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { applyOnKeys, snakeToCamel } from '../../tools';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from '../snack-bar/snack-bar.service';
import { ImportCardpro } from 'src/modules/types/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ImportCardproService {
 apiUrl = environment.apiUrl;
 data;
 sub;

 constructor(private http: HttpClient, private spinnerService: NgxSpinnerService,
             private snackBar: SnackBarService) {
}

  getImportCardProDetails(parameters: {limit: number, offset: number}): Observable<ImportCardpro[]>{
    this.spinnerService.show();
    return this.http.get(`${this.apiUrl}/oppo_forced?offset=${parameters.offset}&limit=${parameters.limit}`).pipe(
      map(cardpro => {
        this.spinnerService.hide();
        this.snackBar.openSnackBar('Cardpro details loaded successfully', 'success');
        return applyOnKeys(cardpro, snakeToCamel);
      }), catchError(error => {
        this.spinnerService.hide();
        this.snackBar.openSnackBar('Failed to load cardpro details', 'error');
        return of([]);
      })
    );
  }

  getImportCardProPaginator(): Observable<number>{
    this.spinnerService.show();
    return this.http.get(`${this.apiUrl}/oppo_forced_paginator`).pipe(
      map(cardpro => {
        this.spinnerService.hide();
        // this.snackBar.openSnackBar('Cardpro details loaded successfully', 'success');
        return applyOnKeys(cardpro, snakeToCamel);
      }), catchError(error => {
        this.spinnerService.hide();
        // this.snackBar.openSnackBar('Failed to load cardpro details', 'error');
        return of(0);
      })
    );
  }

  exportCardProDetails(format: string): void {
    this.spinnerService.show();
    this.http.get(`${this.apiUrl}/arch_export_status?task_id=blacklist/oppo_force_output.${format}`).pipe(
      switchMap((cardpro: {status: number, export_csv_url: string }) => {
        if (cardpro.status !== 200) {
          return of(null);
        }
        // Fetch through HttpClient so the auth interceptor attaches the Bearer token
        return this.http.get(cardpro.export_csv_url, { responseType: 'blob' }).pipe(
          tap(blob => this.saveBlob(blob, cardpro.export_csv_url))
        );
      }),
      tap(() => this.spinnerService.hide()),
      catchError(error => {
        this.spinnerService.hide();
        this.snackBar.openSnackBar('Failed to export', 'error');
        throw error;
      })
    ).subscribe();
  }

  private saveBlob(blob: Blob, url: string): void {
    const fileName = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1));
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    link.click();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 100);
  }
}
